import { ProgressCheckIcon } from './ProgressCheckIcon';

/**
 * author: GreenTurtwig
 * id 943E027B-964A-4CE2-BDD7-44A9703A73B1
 * name progress-check
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/progress-check.svg
 * tags
 */
export const ProgressTickIcon = ProgressCheckIcon;
export default ProgressTickIcon